import { SDK } from "@ing-tours/vue-backend-sdk";

const backend = new SDK({
  baseURL: "/api",
});

export default backend;
